export default __webpack_public_path__ + "static/media/heads-01.adf1598e.svg";